export default __webpack_public_path__ + "static/media/totoro.764be469.png";